module.exports = __webpack_public_path__ + "images/explore2.8c86bc6a4a21b81d3e837606f134cef7.svg";